import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMsmeProfileQuery } from '../hooks/queries/useMsmeWorkspaceQueries';
import { isAdminPortalUser, isSupportPortalUser, isExpertPortalUser } from '../utils/authRole';
import { isPartnerPortalSession } from '../utils/partnerPortalSession';
import {
  firstIncompleteMyCompanyPage,
  myCompanyPagesComplete,
  myCompanyPathAllowedWhileIncomplete,
} from '../utils/myCompanyRequired';

interface RequireMyCompanyPagesProps {
  children: React.ReactElement;
}

const RequireMyCompanyPages: React.FC<RequireMyCompanyPagesProps> = ({ children }) => {
  const location = useLocation();
  const portal = isAdminPortalUser() || isSupportPortalUser() || isExpertPortalUser() || isPartnerPortalSession();
  const profileQuery = useMsmeProfileQuery(!portal);
  if (portal || profileQuery.isLoading || profileQuery.isError || !profileQuery.data?.data) {
    return children;
  }
  const profile = profileQuery.data.data;
  if (
    myCompanyPagesComplete(profile)
    || myCompanyPathAllowedWhileIncomplete(location.pathname)
  ) {
    return children;
  }
  const next = firstIncompleteMyCompanyPage(profile);
  return <Navigate to={next?.path || '/msme-profile'} replace />;
};

export default RequireMyCompanyPages;
